"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Alpha;

var _react = _interopRequireWildcard(require("react"));

var _styled = _interopRequireDefault(require("./styled"));

var _context = require("../../context");

function Alpha() {
  var _useContext = (0, _react.useContext)(_context.ColorPickerContext),
      hex = _useContext.hex,
      rgba = _useContext.rgba,
      hsv = _useContext.hsv,
      tabIndex = _useContext.tabIndex,
      onChange = _useContext.onChange;

  var handleChange = function handleChange(event) {
    var value = parseInt(event.target.value, 10); // eslint-disable-next-line no-restricted-globals

    rgba[3] = isNaN(value) ? 1 : Math.max(0, Math.min(value, 100)) / 100;
    onChange({
      hex: hex,
      rgba: rgba,
      hsv: hsv
    });
  };

  var alpha = Math.round(rgba[3] * 100);
  return /*#__PURE__*/_react["default"].createElement(_styled["default"], {
    value: alpha,
    min: 0,
    max: 100,
    onChange: handleChange,
    tabIndex: tabIndex
  });
}